import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUpIcon, ArrowRightIcon, BarChartIcon } from 'lucide-react';
export function PlatformPredictivePage() {
  return <div className="w-full" data-id="element-7739">
      {/* Hero */}
      <section className="bg-gradient-to-br from-red-900 via-red-800 to-pink-900 text-white py-24" data-id="element-7740">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7741">
          <div className="max-w-3xl" data-id="element-7742">
            <h1 className="text-5xl font-bold mb-6" data-id="element-7743">Predictive Intelligence</h1>
            <p className="text-xl text-red-100 mb-8" data-id="element-7744">
              Propensity models, win-likelihood predictions, channel timing
              optimization, and budget pace forecasting powered by AI.
            </p>
            <div className="flex items-center gap-4" data-id="element-7745">
              <Link to="/planning/forecasting" className="px-6 py-3 bg-white text-red-900 rounded-lg hover:bg-red-50 font-medium" data-id="element-7746">
                Open Forecasting
              </Link>
              <Link to="/website/contact" className="px-6 py-3 border border-white text-white rounded-lg hover:bg-white/10 font-medium" data-id="element-7747">
                Request Demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Features */}
      <section className="py-20 bg-white" data-id="element-7748">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7749">
          <div className="text-center mb-16" data-id="element-7750">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-7751">
              Predictive Capabilities
            </h2>
            <p className="text-lg text-gray-600 mt-4" data-id="element-7752">
              AI-powered insights to optimize your GTM strategy
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7753">
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7754">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7755">
                <TrendingUpIcon className="w-6 h-6 text-red-600" data-id="element-7756" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7757">Propensity Models</h3>
              <p className="text-gray-600" data-id="element-7758">
                AI models that predict which accounts are most likely to
                convert.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7759">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7760">
                <BarChartIcon className="w-6 h-6 text-red-600" data-id="element-7761" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7762">Win Likelihood</h3>
              <p className="text-gray-600" data-id="element-7763">
                Forecast deal outcomes and optimize pipeline management.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-7764">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4" data-id="element-7765">
                <TrendingUpIcon className="w-6 h-6 text-red-600" data-id="element-7766" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-7767">Budget Forecasting</h3>
              <p className="text-gray-600" data-id="element-7768">
                Optimize budget allocation with AI-powered forecasting tools.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA */}
      <section className="py-16 bg-red-50" data-id="element-7769">
        <div className="max-w-5xl mx-auto px-6 text-center" data-id="element-7770">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-7771">
            Ready to predict your GTM success?
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-7772">
            Get started with Predictive Intelligence and transform your GTM
            strategy
          </p>
          <Link to="/planning/forecasting" className="px-8 py-4 bg-red-600 text-white rounded-lg hover:bg-red-700 font-medium inline-flex items-center gap-2" data-id="element-7773">
            Open Forecasting
            <ArrowRightIcon className="w-5 h-5" data-id="element-7774" />
          </Link>
        </div>
      </section>
    </div>;
}